<div class="system-section">
    <p-table [value]="systemParameters">
        <ng-template #header>
            <tr>
                <th style="width: 16%">Hiring Location</th>
                <th style="width: 14%">SSI</th>
                <th style="width: 14%">Extra SSI</th>
                <th style="width: 14%">Markup</th>
            </tr>
        </ng-template>
        <ng-template #body let-item>
            <tr>
                <td>
                    <span>{{item.hiringLocation}}</span>
                </td>
                <td>
                    <input type="text" pInputText [(ngModel)]="item.ssi" [imask]="percentMask" />
                </td>
                <td>
                    <input type="text" pInputText [(ngModel)]="item.extraSSI" [imask]="percentMask" />
                </td>
                <td>
                    <input type="text" pInputText [(ngModel)]="item.markup" [imask]="percentMask" />
                </td>
            </tr>
        </ng-template>
    </p-table>
    <div class="flex gap-2 mt-8">
        <p-button label="Save Changes" [rounded]="true" (click)="saveChanges()" />
        <p-button label="Discard" [rounded]="true" severity="secondary" (click)="discardChanges()" />
    </div>
</div>